// @flow
export const supportEmail = 'support@golfmore.eu';
